import * as XLSX from "xlsx";
import { saveAs } from "file-saver";

/**
 * Export multiple sheets to a single .xlsx file.
 * @param {Array<{name: string, data: Array<Object>}>} sheets
 * @param {string} fileName - e.g. "Revenue_Report"
 */
export function exportToExcel(sheets, fileName) {
  const wb = XLSX.utils.book_new();
  sheets.forEach(({ name, data }) => {
    const ws = XLSX.utils.json_to_sheet(data);
    XLSX.utils.book_append_sheet(wb, ws, name.substring(0, 31));
  });
  const buf = XLSX.write(wb, { bookType: "xlsx", type: "array" });
  saveAs(new Blob([buf], { type: "application/octet-stream" }), `${fileName}.xlsx`);
}

/**
 * Download a base64-encoded XLSX file returned from the backend.
 * @param {string} base64 - base64-encoded xlsx data
 * @param {string} fileName - e.g. "Food_Analytics_2026-02-11_143000.xlsx"
 */
export function downloadBase64File(base64, fileName) {
  const byteCharacters = atob(base64);
  const byteNumbers = new Array(byteCharacters.length);
  for (let i = 0; i < byteCharacters.length; i++) {
    byteNumbers[i] = byteCharacters.charCodeAt(i);
  }
  const byteArray = new Uint8Array(byteNumbers);
  const blob = new Blob([byteArray], {
    type: "application/vnd.openxmlformats-officedocument.spreadsheetml.sheet",
  });
  const link = document.createElement("a");
  link.href = URL.createObjectURL(blob);
  link.download = fileName;
  link.click();
  URL.revokeObjectURL(link.href);
}
